import { FontStyle } from 'app/content/fonts/fonts.data';
import { replaceOrigin } from '../core/ad/utils/url';

export function isElementDescendantOfElement(parentElement: HTMLElement | Element, childElement: any): boolean {
    if (parentElement === childElement) {
        return true;
    }
    let node = childElement.parentNode;
    while (node) {
        if (node === parentElement) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

interface IUrlOption {
    scheme?: 'http:' | 'https:';
    host?: string;
    port?: number;
    pathPrefix?: string;
    path?: string;
}

export function formatUrl(option: IUrlOption): string {
    const scheme = option.scheme || 'http:';
    const host = option.host || 'localhost';
    const port = option.port;
    const pathPrefix = option.pathPrefix || '';
    const path = option.path || '';

    return scheme + '//' + host + (port ? ':' + port : '') + pathPrefix + path;
}

export function isElementDescendantOfElementWithClass(element: any, className: string): boolean {
    if (element.classList && element.classList.contains(className)) {
        return true;
    }
    let node = element.parentNode;
    while (node) {
        if (node.classList && (node as HTMLElement).classList.contains(className)) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

export function isFocused(el: HTMLElement): boolean {
    return el === document.activeElement;
}

export function insertFontFace(fontStyle: FontStyle, document: Document = window.document): void {

    // Don't create a new font-face if it already exists
    if (document.getElementById(fontStyle.id)) {
        return;
    }

    if (window?.bfstudio && !process.env.IN_TEST) {
        fontStyle.fontUrl = replaceOrigin(fontStyle.fontUrl, window?.process?.env?.FONTS_AZURE_STORAGE_CDN_ORIGIN!);
    }

    const fontface = `
        @font-face {
            font-family: "${fontStyle.id}";
            font-weight: ${fontStyle.weight};
            font-style: ${fontStyle.italic ? 'italic' : 'normal'};
            src: url("${fontStyle.fontUrl.replace('storage-emulator', 'localhost')}") format("woff");
        }
    `;

    const fontFaceStyleNode = document.createElement('style');
    fontFaceStyleNode.id = fontStyle.id;

    fontFaceStyleNode.appendChild(document.createTextNode(fontface));

    document.head!.appendChild(fontFaceStyleNode);

}
